import {
  FEED_HEALTH,
  FEED_RUN_STATUSES,
  type FeedHealth,
  type FeedRunStatus,
  LICENCE_STATUSES,
  type LicenceStatus,
} from '@fruuit/shared'
import { Badge, type BadgeTone, StatusBadge } from '@fruuit/ui'

/** Feed run status through the unified tone map (ok, partial, empty, failed, late, running). */
export function RunStatusBadge({ status }: { status: FeedRunStatus }) {
  return <StatusBadge status={status} label={FEED_RUN_STATUSES.labels[status]} />
}

const HEALTH_TONES: Record<FeedHealth, BadgeTone> = {
  healthy: 'positive',
  degraded: 'watch',
  failing: 'attention',
  late: 'attention',
  idle: 'quiet',
  disabled: 'quiet',
}

/** Provider health pill on the Overview and Data feeds screens. */
export function HealthBadge({ health }: { health: FeedHealth }) {
  return (
    <Badge tone={HEALTH_TONES[health]} dot>
      {FEED_HEALTH.labels[health]}
    </Badge>
  )
}

/** Licence state, e.g. Licence pending (GAP-TP-010). No "simulated" label is shown. */
export function LicenceBadges({
  simulated,
  licence,
}: {
  simulated: boolean
  licence: LicenceStatus
}) {
  return (
    <span className="inline-flex flex-wrap gap-1.5">
      {licence !== 'simulated' ? (
        <StatusBadge
          status={licence === 'pending' ? 'licence pending' : licence}
          label={LICENCE_STATUSES.labels[licence]}
        />
      ) : null}
    </span>
  )
}
